import React, { useEffect } from 'react';

import { InputNumber, Select } from 'components/index';
import { OptionWrapper } from 'components/select/select';
import { Numeric } from './types';
import { RowComponentBaseProps } from '../multi-condition/multi-condition';

import './single-numeric-condition.scss';

interface NumericRowProps extends RowComponentBaseProps<Numeric> {
	options: OptionWrapper[];
	parentContainerClass?: string;
	validations: {
		onlyPositive: string;
		toGreaterThanFrom: string;
	};
}

const OPERATOR = 'operator';
const FROM = 'fromValue';
const TO = 'toValue';

const INPUT_WIDTH = 100;
export const OPERATOR_SELECT_WIDTH = 200;

const SingleNumericRow = ({
	singleCondition,
	onChange,
	setIsValid,
	options,
	parentContainerClass,
	validations,
	disabled = false
}: NumericRowProps) => {
	const handleChange = (key, value) => {
		onChange({
			...singleCondition,
			[key]: value
		});
	};
	const isRange = singleCondition.operator === 'IN_RANGE';

	useEffect(() => {
		setIsValid(
			singleCondition.operator &&
				singleCondition.fromValue !== undefined &&
				(!isRange || singleCondition.toValue !== undefined)
		);
	}, [singleCondition]);

	const otherProps = {};
	if (parentContainerClass) {
		otherProps['getPopupContainer'] = () => document.querySelector(`.${parentContainerClass}`);
	}

	const inputValidations = {
		validateFromValue: (condition: Numeric) => condition.fromValue < 0 && validations.onlyPositive,
		validateToValue: (condition: Numeric) =>
			(condition.toValue < 0 && validations.onlyPositive) ||
			(condition.toValue < condition.fromValue && validations.toGreaterThanFrom)
	};

	return (
		<>
			<Select
				disabled={disabled}
				className="numeric-select-operator"
				data-test-id="numeric-select-operator"
				options={options}
				onChange={value => handleChange(OPERATOR, value)}
				value={singleCondition.operator}
				allowClear={true}
				style={{ width: OPERATOR_SELECT_WIDTH }}
				{...otherProps}
			/>
			{singleCondition.operator && (
				<InputNumber
					data-test-id="numeric-value"
					disabled={disabled}
					value={singleCondition.fromValue}
					min={0}
					onChange={value => handleChange(FROM, value)}
					style={{ width: INPUT_WIDTH }}
					error={inputValidations.validateFromValue(singleCondition)}
				/>
			)}

			{isRange && (
				<>
					<div className="numeric-hyphen" data-test-id="numeric-range-hyphen" />
					<InputNumber
						data-test-id="numeric-range-to-value"
						disabled={disabled}
						className="numeric-to-input"
						value={singleCondition.toValue}
						min={0}
						onChange={value => handleChange(TO, value)}
						style={{ width: INPUT_WIDTH }}
						error={inputValidations.validateToValue(singleCondition)}
					/>
				</>
			)}
		</>
	);
};

export default SingleNumericRow;
